export default __webpack_public_path__ + "static/get-new-car-image-2-c9b1744ed6845d13e9d36a183d635290.jpg";